import { combineReducers } from '@reduxjs/toolkit'
import consumerFeatureFlags from './consumerFeatureFlags'

const featureFlag = combineReducers({
  consumerFeatureFlags,
})

export type FeatureFlags = ReturnType<typeof featureFlag>

export default featureFlag
